import React from "react";
import PropTypes from "prop-types";

import { filterItemPropTypes } from "sharedPropTypes";

import { ColorRow } from "components/molecules";

const toggleSelection = (colors, index) => {
  return colors.map((color, i) =>
    i === index ? { ...color, selected: !color.selected } : color
  );
};

const ColorFilter = ({ colors, onChange }) =>
  colors.map((color, index) => (
    <ColorRow
      key={color.value}
      onClick={() => {
        const updatedColors = toggleSelection(colors, index);
        onChange?.("colors", updatedColors, color);
      }}
      color={color}
    />
  ));

ColorFilter.propTypes = {
  onChange: PropTypes.func,
  colors: PropTypes.arrayOf(filterItemPropTypes),
};

export default ColorFilter;
